import { render, staticRenderFns } from "./MyRewards.vue?vue&type=template&id=2582f12c&scoped=true&"
import script from "./MyRewards.vue?vue&type=script&lang=js&"
export * from "./MyRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582f12c",
  null
  
)

export default component.exports